module.exports = __webpack_public_path__ + "2296674332331a33c9e421adb846f844.png";